import { render, staticRenderFns } from "./myMenu.vue?vue&type=template&id=4d56e8fc&scoped=true&"
import script from "./myMenu.vue?vue&type=script&lang=js&"
export * from "./myMenu.vue?vue&type=script&lang=js&"
import style0 from "./myMenu.vue?vue&type=style&index=0&id=4d56e8fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56e8fc",
  null
  
)

export default component.exports